import { useState } from "react";
import TransitionGroup from "react-transition-group/TransitionGroup";
import CSSTransition from "react-transition-group/CSSTransition";
import { createNodeRefs } from "@/common/nodeRefs";
import Swiper from "@/components/shared/Swiper";
import type { ExperienceState } from "@/types/state";

const REGION = "Favorite Image Swiper";

type FavoriteImageSwiperProps = {
  experienceState: ExperienceState;
  onImageSelected: (region: string, index: number) => void;
  onIncrementFavoriteImageIndex: (region: string) => void;
  onDecrementFavoriteImageIndex: (region: string) => void;
};

export default function FavoriteImageSwiper({
  experienceState,
  onImageSelected,
  onIncrementFavoriteImageIndex,
  onDecrementFavoriteImageIndex,
}: FavoriteImageSwiperProps) {
  const [nodeRefFor] = useState(() => createNodeRefs<HTMLDivElement>());

  const metadata = experienceState.experienceData.metadata;
  const favoritesData = experienceState.favoritesData;
  const favoriteImages = favoritesData.getFavoriteArticleImages();

  const images = favoriteImages
    ? favoriteImages.map(image => metadata.getAssetUrl(image.filename))
    : [];

  const nodeRef = nodeRefFor(`details-${favoritesData.favoriteIndex}`);

  return (
    <TransitionGroup
      component="div"
      className="favorite-image-slider tw:relative tw:grow-2 tw:basis-0 tw:bg-[#fff]"
    >
      <CSSTransition
        key={`details-${favoritesData.favoriteIndex}`}
        nodeRef={nodeRef}
        classNames="favorite-image-slider-swiper"
        timeout={200}
      >
        <Swiper
          nodeRef={nodeRef}
          className="favorite-image-slider-swiper tw:h-full tw:w-full"
          config={{
            effect: "slide",
          }}
          images={images}
          index={favoritesData.imageIndex}
          hasButtons={true}
          onIncrementItem={() => onIncrementFavoriteImageIndex(REGION)}
          onDecrementItem={() => onDecrementFavoriteImageIndex(REGION)}
          onItemChanged={index => onImageSelected(REGION, index)}
        />
      </CSSTransition>
    </TransitionGroup>
  );
}
